export default __webpack_public_path__ + "static/media/bannerEvento.15d5f395.png";